"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var TrendsAction_1 = require("@/pages/common/actions/TrendsAction");
var Chart_1 = require("@/pages/common/components/Chart");
var ChartGroupNewType_1 = require("@/pages/common/states/ChartGroupNewType");
var format_1 = require("@/utils/format");
var React = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var ChartRangeType_1 = require("@/pages/chart/states/ChartRangeType");
var mapStateToProps = function (state, ownProps) { return ({
    t: state.trends.t,
    newChartGroups: state.trends.newChartGroups,
    chartPopup: state.trends.chartPopup,
    customFrom: state.trends.customFrom,
    customTo: state.trends.customTo,
    isSelectTypeActive: state.trends.isSelectTypeActive,
    isSelectDurationActive: state.trends.isSelectDurationActive,
    isMobile: ownProps.isMobile || false
}); };
var mapDispatchToProps = function (dispatch) { return ({
    onChartTypeSelect: function (type) { return dispatch(TrendsAction_1.default.onChartTypeSelect(type)); },
    onChartIndexSelect: function (index) { return dispatch(TrendsAction_1.default.onChartIndexSelect(index)); },
    setChartPopup: function (popup) { return dispatch(TrendsAction_1.default.setChartPopup(popup)); },
    onCustomFromChange: function (value) { return dispatch(TrendsAction_1.default.onCustomFromChange(value)); },
    onCustomToChange: function (value) { return dispatch(TrendsAction_1.default.onCustomToChange(value)); },
    onSelectorTypeClick: function () { return dispatch(TrendsAction_1.default.onSelectorTypeClick()); },
    onSelectorDurationClick: function () { return dispatch(TrendsAction_1.default.onSelectorDurationClick()); },
}); };
var trends = function (props) {
    if (!props.newChartGroups || props.newChartGroups.length === 0)
        return null;
    var onCustomFromChange = function (e) { return props.onCustomFromChange(e.target.value); };
    var onCustomToChange = function (e) { return props.onCustomToChange(e.target.value); };
    var getKeyValueOfSelected = function (i, j, chartState, prefix, postfix) {
        if (prefix === void 0) { prefix = ''; }
        if (postfix === void 0) { postfix = ''; }
        var validYLabels = chartState.yLabels.slice(0 - chartState.yLineColors.length);
        var validYLineColors = chartState.yLineColors;
        var rows = chartState.yValues.map(function (it, k) {
            var numericValue = Number(chartState.yValues[k][i]);
            return {
                color: validYLineColors[k],
                title: validYLabels[k] || chartState.title,
                value: (numericValue === 0 ? ' - ' : "" + prefix + format_1.default.comma(numericValue) + postfix).replace(' ($/SF)', ''),
                isLine: true
            };
        });
        if (chartState.yCounts && chartState.yCounts.length) {
            chartState.yCounts.map(function (it, k) {
                var countRow = {
                    color: chartState.yCountColor[k],
                    title: chartState.yCountTitle[k],
                    value: it[i] === 0 ? ' - ' : format_1.default.comma(it[i]),
                    isLine: false,
                };
                rows.push(countRow);
            });
        }
        return rows.reverse();
    };
    var getPrepostFixByChartType = function (chartType) {
        switch (chartType) {
            case ChartGroupNewType_1.ChartGroupNewType.PRICEPERSQUAREFOOT: return ['$', ' / SF'];
            case ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONAMOUNT: return ['$', 'M'];
        }
        return ['', ''];
    };
    var formatTitle = function (title) {
        var titlePcs = title.replace('\n', ' ').split(' ');
        if (titlePcs.length !== 2)
            return title;
        if (titlePcs[0] === ("" + Number(titlePcs[0])).padStart(2, "0") && titlePcs[1] === ("" + Number(titlePcs[1])).padStart(2, "0")) {
            return titlePcs[0] + "/" + titlePcs[1];
        }
        return title;
    };
    var onChartValueSelected = function (chartType) { return function (indexX, indexY, cursorX, cursorY) {
        if (indexX > -1 && cursorX > 0 && cursorY > 0) {
            var _a = getPrepostFixByChartType(chartType), prefix = _a[0], postfix = _a[1];
            var popup = {
                x: cursorX, y: cursorY,
                title: formatTitle(currentChart.xLabels[indexX]),
                rows: getKeyValueOfSelected(indexX, indexY, currentChart, prefix, postfix)
            };
            if (!popup.rows.length) {
                props.setChartPopup(null);
            }
            else {
                props.setChartPopup(popup);
            }
        }
        else {
            props.setChartPopup(null);
        }
    }; };
    var currentChartTypeIndex = props.newChartGroups.findIndex(function (it) { return it.active; });
    var currentChartType = props.newChartGroups[currentChartTypeIndex];
    var currentChartIndex = currentChartType.charts.findIndex(function (it) { return it.active; });
    var currentChart = currentChartType.charts[currentChartIndex];
    var chartId = "chart-" + currentChartTypeIndex + currentChartIndex + "-" + props.customFrom + "-" + props.customTo;
    var renderPopup = function (props) {
        var popupInfo = props.chartPopup;
        var onPopupClicked = function () { return props.setChartPopup(null); };
        if (!popupInfo.title)
            return;
        var renderChartItem = function (row, i) {
            var legendShape = row.isLine ? 'cha__circle' : 'cha__bar';
            return (React.createElement("div", { key: i, className: 'cha__item' },
                React.createElement("div", { className: legendShape, style: { backgroundColor: row.color } }),
                React.createElement("div", { className: 'cha__body' },
                    React.createElement("div", { className: 'cha__body-value' },
                        row.title,
                        ": ",
                        row.value))));
        };
        var popStyle = props.isMobile ? { maxWidth: '100%', pointerEvents: 'all' } : { left: popupInfo.x, top: popupInfo.y, transform: 'translate3d(-100%,-110%,0)', zIndex: 2 };
        return (React.createElement("div", { className: 'cha__pop', style: popStyle, onClick: onPopupClicked },
            props.isMobile ? React.createElement("div", { style: { position: 'absolute', right: 0, top: 0, width: 40, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                React.createElement("span", { className: "fal fa-times" })) : null,
            React.createElement("div", { className: 'cha__key' }, popupInfo.title),
            React.createElement("div", { className: 'cha__group' }, popupInfo.rows.map(renderChartItem))));
    };
    var renderLegends = function (chart) {
        if (!currentChart.isLoaded && currentChart.isError)
            return null;
        var chartLegends = chart.yLabels.map(function (it, i) { return ({
            label: it,
            color: chart.yColors[i],
            textColor: (!chart.yTextColors || chart.yTextColors[i] === undefined) ? 'inherit' : chart.yTextColors[i],
            isLine: true,
        }); });
        chartLegends.push({
            label: props.t.noOfTransactions,
            color: '#81C3BD',
            textColor: '#000',
            isLine: false,
        });
        var renderLegend = function (legend, i) {
            return (React.createElement("a", { key: i, className: "c-trends__label" },
                React.createElement("span", { className: "c-trends__label-" + (legend.isLine ? 'line' : 'bar'), style: { backgroundColor: legend.color } }),
                React.createElement("span", { style: { color: legend.textColor, width: legend.width ? legend.width : 'auto' } }, legend.label)));
        };
        return (React.createElement("div", { className: "c-trends__label-group" },
            React.createElement("div", { className: "c-trends__labels" }, chartLegends.map(renderLegend))));
    };
    var checkShowNoBuildingLineText = function (chart) {
        return chart.yLabels.length > chart.yValues.length;
    };
    var renderFooter = function (props, chart) {
        if (!currentChart.isLoaded && currentChart.isError)
            return null;
        if (!chart || !chart.active)
            return null;
        var showNoBuildingLineText = checkShowNoBuildingLineText(chart);
        if (!showNoBuildingLineText)
            return null;
        return (React.createElement("div", { className: "c-trends__chart-footer" }, props.t.noChartData));
    };
    var renderNotice = function (chart) {
        if (!chart || !chart.active || !chart.noticeText)
            return;
        return (React.createElement("div", { className: "c-trends__chart-footer" }, chart.noticeText));
    };
    var removeNoData = function (chart) {
        if (!chart || !chart.active)
            return;
        var newChart = __assign({}, chart);
        var validYLabels = currentChart.yLabels;
        var validYColors = currentChart.yColors;
        var validYLineColors = currentChart.yLineColors;
        newChart.yLabels = validYLabels;
        newChart.yColors = validYColors;
        newChart.yLineColors = validYLineColors;
        newChart.yTextColors = [];
        return newChart;
    };
    var renderChart = function () {
        if (!currentChart.isLoaded && currentChart.isError)
            return (React.createElement("div", { className: "c-trends__empty" }, props.t.noData));
        if (!currentChart.isLoaded)
            return (React.createElement("div", { className: "c-trends__empty" },
                React.createElement("span", { className: "fal fa-spin fa-spinner" })));
        return React.createElement("div", { className: "c-trends__chart-view", style: { position: 'relative' } },
            React.createElement(Chart_1.chart, __assign({ id: chartId }, removeNoData(currentChart), { isMobile: props.isMobile, onSelected: onChartValueSelected(currentChartType.type) })),
            props.chartPopup ? renderPopup(props) : null);
    };
    var typesClasses = classNames(['c-trends__types', { 'c-trends__types--active-type': props.isSelectTypeActive, 'c-trends__types--active-duration': props.isSelectDurationActive, 'c-trends__types--active': props.isSelectDurationActive || props.isSelectTypeActive }]);
    var currentType = props.newChartGroups.find(function (it) { return it.active; }).title;
    var currentDuration = props.newChartGroups.find(function (it) { return it.active; }).charts.find(function (it) { return it.active; }).title;
    var onSelectorTypeClick = props.onSelectorTypeClick;
    var onSelectorDurationClick = props.onSelectorDurationClick;
    return (React.createElement("div", { className: "c-estate__groups" },
        React.createElement("div", { className: typesClasses },
            React.createElement("div", { className: "c-trends__type-selection-dropdown" },
                React.createElement("div", { onClick: onSelectorTypeClick, className: "c-trends__type-selection-selector c-trends__type-selection-selector--type" },
                    React.createElement("div", { className: "c-trends__dropdown-wrap" },
                        React.createElement("div", { className: "c-trends__dropdown-label" }, currentType),
                        React.createElement("span", { className: "fal fa-chevron-down" }))),
                React.createElement("div", { onClick: onSelectorDurationClick, className: "c-trends__type-selection-selector c-trends__type-selection-selector--duration" },
                    React.createElement("div", { className: "c-trends__dropdown-wrap" },
                        React.createElement("div", { className: "c-trends__dropdown-label" }, currentDuration),
                        React.createElement("span", { className: "fal fa-chevron-down" })))),
            React.createElement("div", { className: "c-trends__type-selection-links" }, props.newChartGroups.map(function (it, i) { return (React.createElement("a", { key: i, onClick: function () { return props.onChartTypeSelect(it.type); }, className: "c-trends__type " + (it.active ? 'c-trends__type--active' : '') }, it.type === ChartGroupNewType_1.ChartGroupNewType.TRANSACTIONAMOUNT ? props.t.transactionActivities : it.title)); }))),
        React.createElement("div", { className: "c-trends__chart" },
            React.createElement("div", { className: "c-trends__toggles" },
                React.createElement("div", { className: "c-trends__time" },
                    React.createElement("div", { className: "c-trends__durations" }, currentChartType.charts.map(function (it, i) { return (React.createElement("a", { key: i, onClick: function () { return props.onChartIndexSelect(i); }, className: "c-trends__duration  " + (it.active ? 'c-trends__duration--active' : '') + " " + (it.yearType === ChartRangeType_1.ChartRangeType.CUSTOM ? 'u-hidden' : '') }, it.title)); })),
                    React.createElement("div", { className: "c-trends__custom" },
                        React.createElement("div", { className: "c-trends__custom-text" }, "From"),
                        React.createElement("div", { className: "c-trends__custom-input" },
                            React.createElement("input", { type: "date", min: "2006-01-01", value: props.customFrom, onChange: onCustomFromChange })),
                        React.createElement("div", { className: "c-trends__custom-text" }, "To"),
                        React.createElement("div", { className: "c-trends__custom-input" },
                            React.createElement("input", { type: "date", min: "2006-01-02", max: new Date().getFullYear() + "-12-31", value: props.customTo, onChange: onCustomToChange })))),
                renderLegends(currentChart)),
            renderChart(),
            renderFooter(props, currentChart),
            renderNotice(currentChart))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(trends);
